import { DirectiveBinding } from 'vue';
import DOMPurify from 'dompurify';

const safeHtmlDirective = {
  // 指令绑定时的声明周期钩子
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    // 清理并设置 HTML
    el.innerHTML = DOMPurify.sanitize(binding.value);
  },
  // 更新时的钩子
  updated(el: HTMLElement, binding: DirectiveBinding) {
    // 更新内容
    el.innerHTML = DOMPurify.sanitize(binding.value);
  },
};

export default safeHtmlDirective;
